/* =========================================================
   CUSTOM MEASUREMENTS (CMX) — WaloneFashion.com
   - Properties disabled by default (Standard mode)
   - Enabled only when Custom mode is selected
   - Mandatory: closing popup incomplete reverts to Standard
   - Intercepts form submit if Custom + incomplete
   ========================================================= */

(function () {
  const root = document.querySelector('[data-cmx]');
  if (!root) return;

  const modal = root.querySelector('[data-cmx-modal]');
  if (!modal) return;

  const orderTypeProp = root.querySelector('[data-cmx-prop="orderType"]');
  const unitProp      = root.querySelector('[data-cmx-prop="unit"]');
  const propInputs    = root.querySelectorAll('input[name^="properties"]');
  const noticeEl      = root.querySelector('[data-cmx-notice]');

  const tabs = root.querySelectorAll('[data-cmx-mode]');

  /* Move modal to body (fixes theme stacking / z-index issues) */
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const closeBtns    = modal.querySelectorAll('[data-cmx-close]');
  const inputs       = modal.querySelectorAll('[data-cmx-input]');
  const addBtn       = modal.querySelector('[data-cmx-add]');
  const alertBox     = modal.querySelector('[data-cmx-alert]');
  const modalWarnEl  = modal.querySelector('[data-cmx-modal-warn]');

  const qtyInput  = modal.querySelector('[data-cmx-qty]');
  const minusBtn  = modal.querySelector('[data-cmx-minus]');
  const plusBtn   = modal.querySelector('[data-cmx-plus]');
  const unitBtns  = modal.querySelectorAll('[data-cmx-unit]');
  const figUnits  = modal.querySelectorAll('[data-cmx-figunit]');
  const figValues = (key) => modal.querySelector(`[data-cmx-fig="${key}"]`);

  function enableProps()  { propInputs.forEach(i => { i.disabled = false; }); }
  function disableProps() { propInputs.forEach(i => { i.disabled = true;  }); }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('cmx-lock', lock);
    document.body.classList.toggle('cmx-lock', lock);
  }

  function revertToStandard() {
    tabs.forEach(t => t.classList.toggle('is-active', t.dataset.cmxMode === 'standard'));
    if (orderTypeProp) orderTypeProp.value = 'Standard';
    disableProps();
    if (noticeEl) noticeEl.hidden = true;
  }

  function openModal(showWarn) {
    modal.hidden = false;
    lockScroll(true);
    if (modalWarnEl) modalWarnEl.hidden = !showWarn;
    validate();
  }

  function closeModal() {
    modal.hidden = true;
    lockScroll(false);
    if (addBtn && addBtn.disabled) {
      revertToStandard();
    }
  }

  /* Toggle mode */
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      if (tab.dataset.cmxMode === 'custom') {
        if (orderTypeProp) orderTypeProp.value = 'Custom';
        enableProps();
        if (noticeEl) noticeEl.hidden = false;
        openModal(false);
      } else {
        if (orderTypeProp) orderTypeProp.value = 'Standard';
        disableProps();
        if (noticeEl) noticeEl.hidden = true;
        closeModal();
      }
    });
  });

  closeBtns.forEach(btn => btn.addEventListener('click', (e) => { e.stopPropagation(); closeModal(); }));

  minusBtn?.addEventListener('click', () => {
    let v = parseInt(qtyInput?.value, 10) || 1;
    qtyInput.value = Math.max(1, v - 1);
  });

  plusBtn?.addEventListener('click', () => {
    let v = parseInt(qtyInput?.value, 10) || 1;
    qtyInput.value = v + 1;
  });

  unitBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      unitBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const u = (btn.dataset.cmxUnit || 'CM').toUpperCase();
      if (unitProp) unitProp.value = u;
      modal.querySelectorAll('[data-cmx-ulabel]').forEach(l => { l.textContent = u.toLowerCase(); });
      figUnits.forEach(el => { el.textContent = u.toLowerCase(); });
      validate();
    });
  });

  function validate() {
    const rangesCM = {
      bust:     { min: 50,  max: 150 },
      waist:    { min: 50,  max: 150 },
      hips:     { min: 50,  max: 150 },
      shoulder: { min: 20,  max: 50  },
      sleeve:   { min: 50,  max: 70  },
      stf:      { min: 120, max: 200 }
    };

    const unit = (unitProp?.value || 'CM').toUpperCase();
    const toIn = (cm) => +(cm / 2.54).toFixed(1);
    function getRange(key) {
      const r = rangesCM[key];
      if (!r) return null;
      return unit === 'IN' ? { min: toIn(r.min), max: toIn(r.max) } : r;
    }

    let valid = true;

    inputs.forEach(input => {
      const key = input.dataset.cmxInput;
      const val = parseFloat(input.value);

      const fig = figValues(key);
      if (fig) fig.textContent = isNaN(val) ? '–' : val;

      const prop = root.querySelector(`[data-cmx-prop="${key}"]`);
      if (prop) prop.value = isNaN(val) ? '' : String(val);

      const range  = getRange(key);
      const guideEl = modal.querySelector(`[data-cmx-guide="${key}"]`);
      if (guideEl && range) guideEl.textContent = `${range.min}–${range.max} ${unit.toLowerCase()}`;

      const errEl = modal.querySelector(`[data-cmx-err="${key}"]`);
      input.classList.remove('cmx-invalid');
      if (errEl) errEl.hidden = true;

      if (isNaN(val) || val <= 0) { valid = false; return; }

      if (range && (val < range.min || val > range.max)) {
        valid = false;
        input.classList.add('cmx-invalid');
        if (errEl) {
          errEl.textContent = `Allowed range: ${range.min}–${range.max} ${unit.toLowerCase()}`;
          errEl.hidden = false;
        }
      }
    });

    if (addBtn) {
      addBtn.disabled = !valid;
      addBtn.setAttribute('aria-disabled', String(!valid));
    }
    if (alertBox) alertBox.hidden = valid;
  }

  inputs.forEach(i => i.addEventListener('input', validate));

  /* Modal Add to Cart — measurements complete:
     sync qty, close modal, then trigger the product form submit.
     Walone's product-form-component.handleSubmit uses FormData,
     so all enabled properties[...] inputs are included automatically.
     50ms delay breaks iOS ghost-tap (prevents touch from landing on
     another button after the modal closes). */
  addBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    const form = root.closest('form');
    if (!form) return;

    // Sync modal qty → real quantity input
    const mainQty = form.querySelector('input[name="quantity"]');
    if (mainQty && qtyInput) mainQty.value = qtyInput.value || '1';

    // Close modal
    modal.hidden = true;
    lockScroll(false);
    if (noticeEl) noticeEl.hidden = true;

    // Delay 50ms to break iOS ghost-tap, then trigger form submit
    setTimeout(() => {
      const submitBtn = form.querySelector('[type="submit"][name="add"]');
      if (submitBtn) {
        form.requestSubmit(submitBtn);
      } else {
        form.requestSubmit();
      }
    }, 50);
  });

  /* Intercept form submit: if Custom mode + incomplete → block and re-open modal */
  const form = root.closest('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (orderTypeProp && orderTypeProp.value === 'Custom') {
        if (addBtn && addBtn.disabled) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openModal(true);
        }
      }
    }, true); // capture phase — runs before product-form-component.handleSubmit
  }

  // Init
  disableProps();
  figUnits.forEach(el => (el.textContent = 'cm'));
  validate();

})();
